import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = {
  class: "accordion accordion-flush accordion-icon-toggle",
  id: "kt_accordion_2"
}
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = {
  class: "accordion-header py-3 d-flex",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_1"
}
const _hoisted_6 = { class: "accordion-icon" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_2_item_1",
  class: "fs-6 collapse ps-10 show",
  "data-bs-parent": "#kt_accordion_2"
}, [
  /*#__PURE__*/_createElementVNode("ul", { class: "py-2" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "py-2" }, "Initial release.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.themeName) + " v1.0.0 - 11 June, 2021 ", 1)
          ]),
          _hoisted_9
        ])
      ])
    ])
  ]))
}